function patch_cardThumbClick(e) {
	e.preventDefault();
	this.parentNode.parentNode.classList.toggle('Card--show');
	document.body.classList.toggle('is-cardShown');
	var id = this.href;
	ga('send', 'event', 'Click', 'Box', id);
}

function patch_cardClick(e) {
	e.stopPropagation();
}

function patch_cardBgClick(e) {
	this.parentNode.classList.remove('Card--show');
	document.body.classList.remove('is-cardShown');
}

document.addEventListener('DOMContentLoaded', function() {

	var flippers = document.getElementsByClassName('Card--flip'),
		thumb = null,
		card = null,
		bg = null;
	if (flippers) {
		for (var i = 0, l = flippers.length; i < l; i++) {
			thumb = flippers[i].querySelector('.CardThumb-wrap');
			if (thumb) {
				thumb.addEventListener('click', patch_cardThumbClick);
			}
			card = flippers[i].querySelector('.CardFull-wrap');
			if (card) {
				card.addEventListener('click', patch_cardClick);
			}
			bg = flippers[i].querySelector('.CardFull');
			if (bg) {
				bg.addEventListener('click', patch_cardBgClick);
			}
		}
	}

});
